import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {FormGroup, AbstractControl, FormBuilder, Validators} from '@angular/forms';
import { ConstituenciesComponent } from "../../constituencies.component";

import { UserAccountApi, ConstituencyApi, CountyApi } from '../../../../../../theme/services/sdk';
import { BaToastNotificationService } from '../../../../../../theme/services/baToastNotification'


@Component({
  selector: 'constituency-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  providers:[UserAccountApi,ConstituencyApi,CountyApi,BaToastNotificationService]
})
export class ConstituencyForm{

  public form:FormGroup;
  public name:AbstractControl;
  public county_id:AbstractControl;
  public submitted:boolean = false;

  county_list:Object;
  constituency:Object;

  constructor(fb:FormBuilder, protected user:UserAccountApi, protected constituencyService:ConstituencyApi, protected county:CountyApi, private route: ActivatedRoute, private router: Router, private toast: BaToastNotificationService, private data: ConstituenciesComponent) {
    this.form = fb.group({
      'name': ['', Validators.compose([Validators.required, Validators.minLength(4)])],
      'county_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])]
    });

    this.name = this.form.controls['name'];
    this.county_id = this.form.controls['county_id'];
    this.user.isAuthenticated()?false:this.router.navigate(['login']);
  }

  ngOnInit() {
    this.county.find().subscribe((res)=>{
      this.county_list = res;
    })
    this.data.constituency.subscribe(data=>this.constituency=data);
  }

  public onSubmit(values:Object):void {
    this.submitted = true;
    if (this.form.valid) {
      let self = this;
      let co;

      if(this.constituency['id']){
        co = this.constituencyService.upsert({
          id: this.constituency['id'],
          name: self.name['value'],
          county_id: self.county_id['value'],
        })
      }else{
        co = this.constituencyService.create({
          name: self.name['value'],
          county_id: self.county_id['value'],
        })
      }

      co.subscribe(res => {
        let msg: string;
        this.data.refresh();
        this.form.reset();
        if(this.constituency['id']){
          this.data.cancelSelected();
          msg = 'Record updated';
        }else{
          msg = 'New constituency added';
        }
        this.toast.success({
          heading: 'Success',
          text: msg,
          stack: 3
        });
      }, err=>{
        this.toast.error({
          heading: err.name,
          text: err.message,
          stack: 3
        });
        console.log(err);
      });
    }
  }

  cancelSelected(){
    this.data.cancelSelected();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/localization/components/constituencies/components/form/form.component.ts